<div class="layout">
  <app-navbar></app-navbar>
  <main class="content">
    <router-outlet></router-outlet>
  </main>
</div>

